export const ALLOWED_MODELS = [
    'stable-diffusion-ultra',
    'stable-diffusion-3-large-turbo',
    'flux-pro',
    'animaginexl-3.1',
  ];
  